export default __webpack_public_path__ + "static/media/linked_approve_users.f6f7749c.svg";